import { database } from "../firebase/config";
import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
} from "firebase/firestore";

const getFantaCollection = (eventKey) =>
  eventKey === "sanremo" ? "fanta_predictions" : `${eventKey}_fanta_predictions`;
const RESULTS_DOC = "fanta_results";
const getResultsCollection = (eventKey) =>
  eventKey === "sanremo" ? "fanta_settings" : `${eventKey}_fanta_settings`;

export const fantaService = {
  // Save user's prediction
  async submitPrediction(
    userId,
    prediction,
    userDisplayName,
    eventKey = "sanremo",
  ) {
    try {
      const userDocRef = doc(database, getFantaCollection(eventKey), userId);
      await setDoc(userDocRef, {
        prediction,
        userId,
        displayName: userDisplayName,
        timestamp: new Date(),
      });
      return true;
    } catch (error) {
      console.error("Error submitting prediction:", error);
      throw error;
    }
  },

  // Get a specific user's prediction
  async getUserPrediction(userId, eventKey = "sanremo") {
    try {
      const userDocRef = doc(database, getFantaCollection(eventKey), userId);
      const docSnap = await getDoc(userDocRef);
      if (docSnap.exists()) {
        return docSnap.data();
      }
      return null;
    } catch (error) {
      console.error("Error getting user prediction:", error);
      throw error;
    }
  },

  // Get all predictions (for leaderboard)
  async getAllPredictions(eventKey = "sanremo") {
    try {
      const q = query(collection(database, getFantaCollection(eventKey)));
      const querySnapshot = await getDocs(q);
      const predictions = [];
      querySnapshot.forEach((doc) => {
        predictions.push(doc.data());
      });
      return predictions;
    } catch (error) {
      console.error("Error getting all predictions:", error);
      throw error;
    }
  },

  // Admin: Set official results, reveal status, and locked status
  async setFantaResults(results, isRevealed, isLocked, eventKey = "sanremo") {
    try {
      const resultsRef = doc(
        database,
        getResultsCollection(eventKey),
        RESULTS_DOC,
      );
      // Get current data to preserve existing fields if not provided
      const currentDoc = await getDoc(resultsRef);
      const currentData = currentDoc.exists() ? currentDoc.data() : {};

      await setDoc(resultsRef, {
        ...currentData,
        results: results !== undefined ? results : currentData.results || [],
        isRevealed:
          isRevealed !== undefined
            ? isRevealed
            : currentData.isRevealed || false,
        isLocked:
          isLocked !== undefined ? isLocked : currentData.isLocked || false,
        updatedAt: new Date(),
      });
      return true;
    } catch (error) {
      console.error("Error setting fanta results:", error);
      throw error;
    }
  },

  // Subscribe to results updates (real-time reveal)
  subscribeToResults(callback, eventKey = "sanremo") {
    const resultsRef = doc(
      database,
      getResultsCollection(eventKey),
      RESULTS_DOC,
    );
    return onSnapshot(resultsRef, (doc) => {
      if (doc.exists()) {
        callback(doc.data());
      } else {
        callback({ results: [], isRevealed: false, isLocked: false });
      }
    });
  },
};
